import { useMemo } from 'react';
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge";


// export function cn(...inputs: any[]) {
//   console.log("cn")
//   return twMerge(clsx(inputs))
// }

export function cn(...inputs: any[]) {
  const result = twMerge(clsx(inputs));
  // if (process.env.NODE_ENV !== "production") {
  //   console.log("cn called with", inputs, "→", result);
  // }
  return result;
}